module.exports = __webpack_public_path__ + "img/hn.81ab9078.svg";